import axios from "axios";
import {API_URL, RE_API_URL} from "../../utils/constants";
import AuthenticationService from "../AuthenticationService";

export default class ApiService {


  static getHeaders() {
    const userData = AuthenticationService.getUserData();
    return {"authorizationToken": userData.access_token}
  }


  static async getApi(typeObject, args) {
    const baseUrl = `${API_URL}/${typeObject}/`;

    const url = args === undefined ? baseUrl : baseUrl + `${args}`;
    return await axios
      .get(url, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async postApi(typeObject, data) {
    return await axios.post(`${API_URL}/${typeObject}/`, {data}, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async publicPostApi(typeObject, data) {
    return await axios.post(`${API_URL}/${typeObject}/`, {data})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async deleteApi(typeObject) {
    return await axios.delete(`${API_URL}/${typeObject}/`, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async deleteWithDataApi(typeObject, data) {
    console.log("data", JSON.stringify(data))
    return await axios
      .delete(`${API_URL}/${typeObject}/`,
        {params: data, headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  // New Api Services Method
  static async getEntries(typeObject) {
    const uri = `${API_URL}/${typeObject}`;

    return await axios
      .get(uri, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async getEntry(typeObject, id) {
    const uri = `${API_URL}/${typeObject}/${id}`;

    return await axios
      .get(uri, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }


  static async createEntry(typeObject, data) {
    const uri = `${API_URL}/${typeObject}`;

    return await axios
      .post(uri, {data}, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async deleteEntry(typeObject, id) {
    const uri = `${API_URL}/${typeObject}/${id}`;

    return await axios
      .delete(uri, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async updateEntry(typeObject, id, data) {
    const uri = `${API_URL}/${typeObject}/${id}`;

    return await axios
      .post(uri, {data}, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }


  static async addESDocument(typeObject, data, document_id) {
    const uri = `${RE_API_URL}/${typeObject}/add`;
    let temp_headers = this.getHeaders()
    temp_headers['doc_id'] = document_id
    return await axios.put(uri, {data}, {headers: temp_headers})
      .then((response) => console.log(response.data))
      .catch((error) => {
        throw error;
      });
  }

  static async updateESDocument(typeObject, data, document_id) {
    const uri = `${RE_API_URL}/${typeObject}/update`;
    let temp_headers = this.getHeaders()
    temp_headers['doc_id'] = document_id
    return await axios.post(uri, {data}, {headers: temp_headers})
      .then((response) => console.log(response.data))
      .catch((error) => {
        throw error;
      });
  }

  static async postREApi(typeObject, data) {
    return await axios.post(`${RE_API_URL}/${typeObject}/`, {data}, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async deleteESDocument(typeObject, data, document_id) {
    let temp_headers = this.getHeaders()
    temp_headers['doc_id'] = document_id
    return await axios.delete(`${RE_API_URL}/${typeObject}/delete`, {headers: temp_headers})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async deleteTemaOrMacrotema(typeObject, header) {
    let temp_headers = this.getHeaders()
    Object.keys(header).forEach(i => {
      temp_headers[i] = header[i]
    })
    return await axios.delete(`${RE_API_URL}/${typeObject}/`, {headers: temp_headers})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async updateTemaOrMacrotema(header) {
    return await axios.get(`${RE_API_URL}/faqs/themes/update/`, {headers: header})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  static async getKeywordsExtraction(typeObject, data) {
    return await axios.post(`${RE_API_URL}/${typeObject}/keyword/`, {data}, {headers: this.getHeaders()})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }


}
